import React from "react";
import { tableHeaderColor } from "../utility/Common";

const AboutModal = ({ setIsModalOpen }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={() => setIsModalOpen(false)}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className={`${tableHeaderColor} sticky top-0 text-white p-6 rounded-t-2xl flex justify-between items-center`}>
          <h2 className="text-3xl font-bold">About Harsha</h2>
          <button
            onClick={() => setIsModalOpen(false)}
            className="text-white hover:text-gray-200 transition duration-300"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-8">
          <div className="flex flex-col md:flex-row gap-8 mb-8">
            <div className="flex-shrink-0">
              <img
                src="images/harsha sir profile.png"
                alt="Harsha"
                className="w-64 h-64 object-cover rounded-xl"
              />
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                HARSHA AMARAKOON
              </h3>
              <ul className="space-y-2">
                <li className="text-gray-600">
                  B.Sc Mgt(Sp) University of Jayawardenapura
                </li>
                <li className="text-gray-600">
                  Former Teacher at Nalanda College, Colombo 10{" "}
                </li>
                <li className="text-gray-600">
                  Former Visiting Lecturer at St Joseph’s College. Colombo{" "}
                </li>
              </ul>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 mt-8">
                <div className="bg-primary-50 p-6 rounded-xl">
                  <div className="text-3xl font-bold text-primary-600 mb-2">
                    15+
                  </div>
                  <div className="text-gray-700 font-semibold">
                    Years of Experience
                  </div>
                </div>
                <div className="bg-green-50 p-6 rounded-xl">
                  <div className="text-3xl font-bold text-green-600 mb-2">
                    500+
                  </div>
                  <div className="text-gray-700 font-semibold">
                    Students Taught
                  </div>
                </div>
                <div className="bg-yellow-50 p-6 rounded-xl">
                  <div className="text-3xl font-bold text-yellow-600 mb-2">
                    50+
                  </div>
                  <div className="text-gray-700 font-semibold">
                    Top Rankings
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Expert Economics Educator
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              I am Harsha Amarakoon, a seasoned lecturer specialized in
              Economics with a strong academic background and over 14 years of
              experience in teaching G. C. E. Advanced Level Students in the
              Commerce stream.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              My journey began with a Bachelor's degree in Management studies
              and Commerce from the University of Sri Jayawardenapura. This
              foundational education provided me with a robust understanding of
              economic theory and its practical applications in various sectors.
              Thereafter, I served as a teacher at Nalanda College, Colombo 10,
              for two years where I contributed to the academic development of
              young minds.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              I also had the privilege to serve as a Visiting Lecturer at St.
              Joseph’s College, Colombo, further expanding my reach and impact
              in teaching economics. My teaching philosophy emphasizes active
              learning methodologies that empower students to analyze economic
              trends, explore contemporary challenges, and propose innovative
              solutions.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Currently, I serve as a dedicated educator at Unique Higher
              Education Center Mathale, Science Center Kegalle and Sesip
              Rambukkana where I instruct and mentor over 10,000 students
              annually, fostering a stimulating and inclusive learning
              environment where students are inspired to explore the
              complexities of economics and develop the skills necessary for
              future success.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              My commitment and special skills in empowering students to analyze
              economic trends, explore contemporary challenges, and develop
              innovative solutions has been a huge success and hence, an
              overwhelming number of students attend my classes around Sri
              Lanka, especially in Kegalle, Rabukkana and Matale districts.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              I am proud to mention that more than 2000 of my students have been
              selected to universities so far, to pursuer their dreams.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              As I continue my journey with commitment and dedication, I look
              forward to contributing further to the field of economics
              education in preparing the next generation of leaders and thinkers
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
